import { render, staticRenderFns } from "./HealthCheckSettings.vue?vue&type=template&id=1f93a530&scoped=true"
import script from "./HealthCheckSettings.vue?vue&type=script&lang=ts"
export * from "./HealthCheckSettings.vue?vue&type=script&lang=ts"
import style0 from "./HealthCheckSettings.vue?vue&type=style&index=0&id=1f93a530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93a530",
  null
  
)

export default component.exports